import { render, staticRenderFns } from "./SchedaPreset.vue?vue&type=template&id=ffd5a6f4&"
import script from "./SchedaPreset.vue?vue&type=script&lang=js&"
export * from "./SchedaPreset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports